import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from "ng-recaptcha";
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { AbstractControl, FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";

// ENVIRONMENT
import { environment } from "../../../../environments/environment";

// SERVICES
import { CmsService } from 'src/app/Services/cms.service';
import { ApiService } from "src/app/Services/api.service";
import { ExternalService } from 'src/app/Services/external.service';

@Component({
  selector: 'app-apoio-passageiro',
  templateUrl: './apoio-passageiro.component.html',
  standalone: false
})
export class ApoioPassageiroComponent implements OnInit {
  @ViewChild('top') top: ElementRef | undefined;

  municipalities: any[] = [];

  private token: string = '';
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.Portugal, CountryISO.Spain, CountryISO.France];

  lines: any[] = []
  lineOperator: string = '';
  lineOperatorLogos: any[] = [];
  unknownOperator: boolean = false;

  stops: any[] = []

  bsValue = new Date();
  bsConfig: Partial<BsDatepickerConfig> = {};
  minDate  = new Date();
  maxDate = new Date();

  form: FormGroup = new FormGroup({});

  showForm: boolean = true;

  complaint: boolean = false;
  private sendToBo: boolean = false;
  suggestion: boolean = false;
  municipalityRequired: boolean = false;
  lineRequired: boolean = false;
  submitted : boolean = false;
  inProgress : boolean = false;
  success : boolean = false;
  successComplaint : boolean = false;
  addedComplaintId: string = '';
  addedComplaintIdentifier: string = '';
  selectedFiles: File[] = [];
  fileError: string | null = null;
  fileErrorMax: string | null = null;
  errorOnFiles: boolean = false;

  file: string = ''
  sizeOver: string = ''
  alreadyExists: string = ''
  notAllowed: string = ''
  allowedExtensions: any[string] = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx'];

  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  supportPage_content: string = 'linhas-apoio-ao-passageiro';
  supportPageInfo: any = {};

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private formBuilder: FormBuilder,
    private externalService: ExternalService,
    private apiService: ApiService,
    private http: HttpClient,
    private cmsService: CmsService,
    private translate: TranslateService,
    private title: Title,
    private router: Router
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['apoioPassageiros']
      this.title.setTitle(pageTitle);
    })

    this.translate.get('formErrorFeedback').pipe().subscribe(trans => {
      this.file = trans['file'];
      this.sizeOver = trans['sizeOver'];
      this.alreadyExists = trans['alreadyExists'];
      this.notAllowed = trans['notAllowed'];
    });

    this.setDateRange();

    this.configureDatepicker();
  }

  ngOnInit(){
    
    this.initFormPassengerSupport();

    this.getContent();

    this.getMunicipalities();

    this.getRecaptchaToken();

    const captchaInterval = setInterval(() => {
      this.getRecaptchaToken();
    }, 110000);
  }

  initFormPassengerSupport(): void {
    this.form = this.formBuilder.group(
      {
        firstName: ['', [Validators.required, Validators.pattern(/^\S.*$/)]],
        lastName: ['', [Validators.required, Validators.pattern(/^\S.*$/)]],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', Validators.required],
        subject: ['', Validators.required],
        subsubject: [''],
        municipality: [''],
        line: [''],
        stop: [''],
        place: [''],
        time: [''],
        date: [new Date(), [Validators.required]],
        message: [
          '',
          [
            Validators.required,
            Validators.pattern(/^( *|\S.*)(\r?\n( *|\S.*))*$/),
            Validators.minLength(20),
            Validators.maxLength(500),
          ],
        ],
        files: [''],
        acceptTerms: [false, Validators.requiredTrue],
      },
    );

    this.onChanges();
  }

  setDateRange(): void {
    const today = new Date();
    this.minDate.setDate(today.getDate() - 30);
    this.maxDate.setDate(today.getDate());
  }

  configureDatepicker(): void {
    this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      minDate: this.minDate,
      maxDate: this.maxDate
    };
  }

  getRecaptchaToken() {
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {
        this.token = token;
      });
  }

  getContent(){
    this.cmsService.getContentList(this.supportPage_content, this.language).subscribe(
      {
        next: data => {
          this.supportPageInfo = data['body']['data'];

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getMunicipalities(){
    this.externalService.getMunicipalities().subscribe(
      {
        next: data => {

          this.municipalities.splice(0)
          
          data.forEach(element => {
            let mun = {
              name: element['pDescricao'],
              code: element['pDescricao'],
              key: element['pKey'],
              region: element['pNUTIII']
            }

            this.municipalities.push(mun)
          });

          this.municipalities = this.municipalities.sort((a: any, b: any) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }) );
        },
        error: er => {
        this.router.navigate(['/500']);
        } 
      })
  }

  onFileChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (!target.files) return;

    const files = Array.from(target.files);

    this.fileError = '';
    this.fileErrorMax = '';

    let validFiles: File[] = []

    files.forEach(file => {
      if (file.size > 5 * 1024 * 1024) {
        this.fileError +=  `"${this.file}${file.name}${this.sizeOver}"<br>`;
      } else {
        const exists = this.selectedFiles.some(
          selectedFile => selectedFile.name === file.name && selectedFile.size === file.size
        );
        if (exists) {
          this.fileError += `"${this.file}${file.name}${this.alreadyExists}"<br>`;
        } else {

          const fileExtension = file.name.split('.').pop()?.toLowerCase();
          if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
            this.fileError += `"${this.file}${file.name}${this.notAllowed}"<br>`;
            target.value = ''; // Clear input
          } else {
            validFiles.push(file)
          }
        }
      }
    })

    validFiles.forEach(file => {
      this.selectedFiles.push(file);
    })
  }

  removeFile(file: File): void {
    this.selectedFiles = this.selectedFiles.filter(
      selectedFile => !(selectedFile.name === file.name && selectedFile.size === file.size)
    );
  }

  onSubmitFile(complaintIdendifier: string){
    try {
      this.errorOnFiles = false;
      let filesToAdd = this.selectedFiles.length;
      let filesAdded = 0;

      if(filesToAdd > 0) {
        for (const file of this.selectedFiles) {
          const fileFormData = new FormData();

          const renamedFile = new File([file], complaintIdendifier + '/open_' + file.name, { type: file.type });

          fileFormData.append('file', renamedFile);
          fileFormData.append('name', 'compaints/' + renamedFile.name);

          const type = 'REQUESTS';

          this.apiService.createFile(fileFormData, type)
            .subscribe({
              next: data => {
                filesAdded++;
                if(filesAdded == filesToAdd){
                  this.selectedFiles = [];
                  this.showForm = false;
                  this.submitted = false;
                  this.inProgress = false;
                  this.successComplaint = true;
                  this.top?.nativeElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
                  this.form.reset();
                  this.form.get('subject')?.setValue('');
                  this.form.get('municipality')?.setValue('');
                  this.form.get('line')?.setValue('');
                  this.form.get('stop')?.setValue('');
                  setTimeout(() => {
                    this.successComplaint = false;
                    this.addedComplaintId = '';
                    this.addedComplaintIdentifier = '';
                    window.location.reload()
                  }, 5000);
                }

              },
              error: er => {
                filesAdded++;
                if(filesAdded == filesToAdd){
                  this.selectedFiles = [];
                  this.showForm = false;
                  this.errorOnFiles = true;
                  this.submitted = false;
                  this.inProgress = false
                  this.successComplaint = true;
                  this.top?.nativeElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
                  this.form.reset();
                  this.form.get('subject')?.setValue('');
                  this.form.get('municipality')?.setValue('');
                  this.form.get('line')?.setValue('');
                  this.form.get('stop')?.setValue('');
                  setTimeout(() => {
                    this.successComplaint = false;
                    this.addedComplaintId = '';
                    this.addedComplaintIdentifier = '';
                    window.location.reload()
                  }, 5000);
                }
              }
            });

        }
      } else {
        this.selectedFiles = [];
        this.showForm = false;
        this.errorOnFiles = false;
        this.submitted = false;
        this.inProgress = false
        this.successComplaint = true;
        this.top?.nativeElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.form.reset();
        this.form.get('subject')?.setValue('');
        this.form.get('municipality')?.setValue('');
        this.form.get('line')?.setValue('');
        this.form.get('stop')?.setValue('');
        setTimeout(() => {
          this.successComplaint = false;
          this.addedComplaintId = '';
          this.addedComplaintIdentifier = '';
          window.location.reload()
        }, 5000);
      }

    } catch (error) {
      console.error('Error uploading files', error);
    }
  }

  onChanges(){
    this.form.get('subject')?.valueChanges.subscribe(
      val => {
        if (val == 'COMPLAINT'){
          this.complaint = true;
          this.sendToBo = true;
          this.suggestion = false;
          this.municipalityRequired = true;
          this.lineRequired = true;
          this.form.get('municipality')?.setValidators([Validators.required]);
          this.form.get('line')?.setValidators([Validators.required]);
          this.form.get('subsubject')?.setValidators([Validators.required]);
        } else if (val == 'LOST_AND_FOUND' || val == 'DOCUMENT_REQUEST'){
          this.complaint = false
          this.sendToBo = true;
          this.suggestion = false;
          this.municipalityRequired = true;
          this.lineRequired = true;
          this.form.get('municipality')?.setValidators([Validators.required]);
          this.form.get('line')?.setValidators([Validators.required]);
          this.form.get('subsubject')?.setValidators([]);
        } else if (val == 'INFORMATION_REQUEST') {
          this.complaint = false
          this.sendToBo = true;
          this.suggestion = false;
          this.municipalityRequired = true;
          this.lineRequired = true;
          this.form.get('municipality')?.setValidators([Validators.required]);
          this.form.get('line')?.setValidators([Validators.required]);
          this.form.get('subsubject')?.setValidators([]);
        } else if (val == 'SUGGESTION' || val == 'COMPLIMENT') {
          this.complaint = false
          this.sendToBo = true;
          this.suggestion = false;
          this.municipalityRequired = false;
          this.lineRequired = false;
          this.form.get('municipality')?.setValidators([]);
          this.form.get('line')?.setValidators([]);
          this.form.get('subsubject')?.setValidators([]);
        } else {
          this.complaint = false
          this.sendToBo = false;
          this.suggestion = false;
          this.municipalityRequired = false;
          this.lineRequired = false;
          this.form.get('municipality')?.setValidators([]);
          this.form.get('line')?.setValidators([]);
          this.form.get('subsubject')?.setValidators([]);
        }
        this.form.get('subsubject')?.updateValueAndValidity();
        this.form.get('municipality')?.updateValueAndValidity();
        this.form.get('line')?.updateValueAndValidity();
      }
    )

    this.form.get('municipality')?.valueChanges.subscribe(
      val => {
        this.lineOperator = '';
        this.form.get('line')?.setValue('');
        this.form.get('stop')?.setValue('');

        if(val != '') {
          this.listRoutesByMunicipality(val);
        } else {
          this.lines.splice(0);
          this.stops.splice(0); 
        }
      }
    )

    this.form.get('time')?.valueChanges.subscribe(
      val => {
        if(val == null) {
          this.form.get('time')?.setValue(null, { emitEvent: false });
        }
      }
    )

    this.form.get('line')?.valueChanges.subscribe(
      val => {
        this.lineOperator = ''
        this.lineOperatorLogos = [];
        if(val != ''){
          let ln = this.lines.find(ln => ln.number === val)
          if (ln != undefined) {

            if(ln['operator'] == 'DESCONHECIDO' || ln['operator'] == ''){
              this.lineOperator = 'DESCONHECIDO'
              this.unknownOperator = true;
            } else {
              this.lineOperator = ln['operatorCode']
              this.lineOperatorLogos = ln['operatorLogos'];
              this.unknownOperator = false;
            }

            let route_id = ln['codeCIM'];
            this.listStopsByRoute(route_id);
          }
        }
      }
    )

    this.form.get('message')?.valueChanges.subscribe(
      value => {
        if(value != '' && value != null) {
          const trimmed = value
            .split('\n')
            .map((line :any) => line.replace(/^\s+/, ''))
            .join('\n');

          this.form.get('message')!.setValue(trimmed, { emitEvent: false });  
        }
      }
  );
  }

  listRoutesByMunicipality(municipality: string){
    this.lines.splice(0);

    this.externalService.getRoutesByMunicipality(municipality).subscribe(
      {
        next: data => {
          data.forEach(item => {
            let opCode = '';
            let opLogos = [];
            switch (true) {
              case (item['pdesigOperador'] as any).toLowerCase().startsWith("transdev"):
                opCode = 'Transdev Norte';
                opLogos.push('transdev');
                break;
              case (item['pdesigOperador'] as any).toLowerCase().startsWith("expressdiagram"):
                opCode = 'Valpi, Rodonorte';
                opLogos.push('valpi');
                opLogos.push('rodonorte');
                break;
              case (item['pdesigOperador'] as any).toLowerCase().startsWith("etapas"):
                opCode = 'AVPacense, Valpi';
                opLogos.push('avpacense');
                opLogos.push('valpi');
                break;
              case (item['pdesigOperador'] as any).toLowerCase().startsWith("rota"):
                opCode = 'Rodonorte, AVLandim';
                opLogos.push('rodonorte');
                opLogos.push('avlandim');
                break;
              default:
                opCode = '';
            }
            let line = {
              number: item['pCodCarOperador'],
              name: item['pDesignacao'],
              municipality: municipality,
              operator: item['pdesigOperador'],
              operatorCode: opCode,
              operatorLogos: opLogos,
              codeCIM: item['pCodCarCIM'],
              color: item['pColorHex']
            }

            this.lines.push(line);
          });
          
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  listStopsByMunicipality(municipality: string){
    this.stops.splice(0);

    this.externalService.getStopsByMunicipality(municipality).subscribe(
      {
        next: data => {
          data.forEach(item => {
            let stop = {
              id: '1:' + item['stop_id'],
              code: item['stop_id'],
              name: item['stop_name'],
              municipality: '',
              lat: item['lat'],
              lng: item['lon'],
              zone: item['zone_id']
            }

            this.stops.push(stop);

            this.stops.sort((a: any, b: any) => a.name < b.name ? -1 : 1 );
          });
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  listStopsByRoute(route_id: string){
    this.stops.splice(0);

    let params = {  
      "offset": 0,
      "limit": 2000,
      "include": true,
      route_ids: [route_id]
    }

    this.apiService.getStopsByRoute(params).subscribe(
      {
        next: data => {
          let results = data['body']['results'];
          
          results.forEach((item: any) => {
            let stop = {
              id: '1:' + item['stop_id'],
              code: item['stop_id'],
              name: item['stop_name'],
              municipality: '',
              lat: item['lat'],
              lng: item['lon'],
              zone: item['zone_id']
            }

            this.stops.push(stop);

            this.stops.sort((a: any, b: any) => a.name < b.name ? -1 : 1 );
          });
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    this.inProgress = true;
    this.success = false;
    this.successComplaint = false;
    this.fileErrorMax = '';

    if (this.form.invalid || this.selectedFiles.length > 5) {
      if(this.selectedFiles.length > 5){
        this.fileErrorMax = 'Só são permitidos até 5 ficheiros.';
      }
      this.inProgress = false;
      return;
    } else {
      let name = this.form.get('firstName')?.value.trim() + ' ' + this.form.get('lastName')?.value.trim()
      let email = this.form.get('email')?.value.trim();
      let phone = this.form.get('phone')?.value != null ? this.form.get('phone')?.value['internationalNumber'] : 'N/A';
      let line = this.form.get('line')?.value;
      let stop = this.form.get('stop')?.value;
      let ln = this.lines.find(ln => ln.number === this.form.get('line')?.value)
      let operator = '';
      let line_name = '';

      let translatedText = this.translate.instant('complaintDetail.' + this.form.get('subject')?.value.trim());
      let subject = this.form.get('subject')?.value.trim();
      let subsubject = this.form.get('subsubject')?.value.trim() != '' ? this.form.get('subsubject')?.value.trim().split('##')[0] : translatedText;
      let message = this.form.get('message')?.value.trim();
      let place = this.form.get('place')?.value;
      let mun = this.municipalities.find(mun => mun.code === this.form.get('municipality')?.value)
      let municipality = mun != undefined ? mun['name'] : ''
      let time = ''
      if(this.form.get('time')?.value != null && this.form.get('time')?.value != ''){
        time = this.form.get('time')?.value.getHours().toString().padStart(2, '0') + ':' +
          this.form.get('time')?.value.getMinutes().toString().padStart(2, '0');
      }
      let date = new Date(this.form.get('date')?.value).toISOString().split('T')[0] + 'T00:00:00Z'

      if (ln != undefined){
        line_name = ln['name'];

        if(this.form.get('subsubject')?.value.trim().split('##')[1] != 'false'){
          switch (true) {
            case ln['operator'].toLowerCase().startsWith("transdev"):
              operator = 'TRD';
              break;
            case ln['operator'].toLowerCase().startsWith("expressdiagram"):
              operator = 'EXP';
              break;
            case ln['operator'].toLowerCase().startsWith("etapas"):
              operator = 'ETR';
              break;
            case ln['operator'].toLowerCase().startsWith("remote"):
              operator = 'ETR';
              break;
            case ln['operator'].toLowerCase().startsWith("rota"):
              operator = 'RDR';
              break;
            default:
              operator = '';
          }
        } else {
          operator = 'CIMTS';
        }
      } else {
        operator = 'CIMTS';
      }

      if (this.sendToBo) {
        let params = {
          requested_by_name: name,
          requested_by_email: email,
          ref: operator + '##' + line,
          ref_type: 'OPERATOR',
          type: subject,
          subject: subsubject,
          body: message,
          occurrence_date: date,
          extra:{
            phone: phone,
            place: place,
            time: time,
            municipality: municipality,
            line: line + ' - '+ line_name,
            stop: stop
          }
        }

        this.apiService.createComplaint(params, this.token).subscribe(
          data => {
            this.addedComplaintId = data['body']['id'];
            this.addedComplaintIdentifier = data['body']['identifier'];

            this.onSubmitFile(this.addedComplaintIdentifier);
          },
          error => {
            this.showForm = true;
            this.submitted = false;
            this.inProgress = false;
            this.form.get('acceptTerms')?.setValue(false);
          }
        )

      } else {
        let mailsubject = 'Novo contacto (' + translatedText + ') de ' + name

        let message = 'Nome: ' + name + '\n' +
          'E-mail: ' + email + '\n' +
          'Telefone: ' + phone + '\n\n' +
          'Assunto: ' + translatedText

        if(!this.suggestion){
          message = message + '\n' +
            'Município: ' + municipality + '\n' +
            'Linha: ' + line + ' - '+ line_name + '\n' +
            'Paragem: ' + stop + '\n' +
            'Local: ' + place + '\n' +
            'Hora: ' + time
        }

        message = message + '\n\n' +
          'Mensagem: ' + this.form.get('message')?.value.trim()

        let attachments: any[] = []
        let filesProcessed = 0;
        let params = {}

        if(this.selectedFiles.length > 0){
          let attachText = ''

          for (const file of this.selectedFiles) {
            const reader = new FileReader();

            reader.onload = () => {
              const base64String = (reader.result as string).split(",")[1];
              let fileToAdd = {
                content: base64String,
                filename: file['name'],
                type: file['type'],
                disposition: "attachment"
              }

              attachText = attachText + file['name'] + ', '

              attachments.push(fileToAdd)

              filesProcessed++;
              if (filesProcessed === this.selectedFiles.length) {

                message = message + '\n\n' +
                'Anexos: ' + attachText.slice(0, -2)

                params = {
                  email: email,
                  subject: mailsubject,
                  message: message,
                  attachments: attachments
                }

                this.sendEmail(params);
              }
            };

            reader.readAsDataURL(file);
          }
        } else {
          params = {
            email: email,
            subject: mailsubject,
            message: message
          }

          this.sendEmail(params);
        }
      }
    }
  }

  sendEmail(params: {}){

    this.apiService.sendEmail(params, this.token).subscribe(
      data => {
        this.selectedFiles = [];
        this.showForm = false;
        this.submitted = false;
        this.inProgress = false;
        this.success = true;
        this.top?.nativeElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.form.reset();
        this.form.get('subject')?.setValue('');
        this.form.get('subsubject')?.setValue('');
        this.form.get('municipality')?.setValue('');
        this.form.get('line')?.setValue('');
        this.form.get('stop')?.setValue('');
        setTimeout(() => {
          this.success = false;
          window.location.reload()
        }, 5000);
      },
      error => {
        this.showForm = true;
        this.submitted = false;
        this.inProgress = false;
        this.form.get('acceptTerms')?.setValue(false);
      }
    )
  }

  onReset(): void {
    this.submitted = false;
    this.inProgress = false
    this.form.reset();
    this.form.get('subject')?.setValue('');
    this.form.get('municipality')?.setValue('');
    this.form.get('line')?.setValue('');
    this.form.get('stop')?.setValue('');
  }
}
